var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isCompleted)?_c('pdf-viewer-template',{staticClass:"manual-academy-pdf",attrs:{"pdfBlob":_vm.pdfBlob,"eventTimeout":_vm.eventTimeout,"eventDownload":_vm.downloadPdf},scopedSlots:_vm._u([{key:"downloadLabel",fn:function(){return [_vm._v("ダウンロード")]},proxy:true}],null,false,3841189442)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }